import { componentProvider } from 'js-component-framework';
import getFormattedClassnames from 'utils/getFormattedClassnames';
import CookieBanner from './cookie-banner';
import './cookie-banner.scss';

const cookieClassnames = sciencenewsClassnames['cookie-banner'];
const cookieSelectors = getFormattedClassnames(cookieClassnames);

const cookieBannerConfig = {
  name: 'cookie-banner',
  component: CookieBanner,
  querySelector: {
    button: cookieSelectors.button,
  },
};

componentProvider(cookieBannerConfig);
